import {
  ExerciseSuggestion,
  useExerciseSuggestions,
} from '@client/new/helpers/exercise-suggestions';

export type { ExerciseSuggestion };

export type ExerciseSuggestionsModel = {
  exerciseSuggestions: ExerciseSuggestion[];
};

export const useExerciseSuggestionsModel = (
  title: string,
): ExerciseSuggestionsModel => ({
  exerciseSuggestions: useExerciseSuggestions(title),
});
